import { render, staticRenderFns } from "./CampaignMetric.vue?vue&type=template&id=2842a63b&scoped=true&"
import script from "./CampaignMetric.vue?vue&type=script&lang=js&"
export * from "./CampaignMetric.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMetric.vue?vue&type=style&index=0&id=2842a63b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842a63b",
  null
  
)

export default component.exports